import * as THREE from "three";
import {
  AR_EVENTS,
  AR_PLATFORM,
  AR_POSITION_SEEK,
  AR_SUPPORT,
} from "../constants";
import Event from "./Event";

window.THREE = THREE;

const mod = () => {
  let support = AR_SUPPORT.INITIALIZING;
  let reason = "INITIALIZING";
  let scene = null;
  let camera = null;
  let renderer = null;
  let planeMaterial = null;
  let ground = null;
  let session = false;
  let hitTestStatus = false;
  let seekStartEvent = false;
  const hitTestPosition = new THREE.Vector3();
  const hitTestRotation = new THREE.Quaternion();
  const raycaster = new THREE.Raycaster();
  const tapPosition = new THREE.Vector2(0, 0);
  let hittestCallback = null;

  const isSupported = () => ({
    platform: AR_PLATFORM.EIGHTHWALL,
    support,
    reason,
  });

  const initXrScene = (setUpScene) => {
    console.log("8th Wall Init Scene");
    const { XR8 } = window;
    ({ scene, camera, renderer } = XR8.Threejs.xrScene()); // Get the 3js scene from XR8.Threejs
    renderer.physicallyCorrectLights = true;
    renderer.outputEncoding = THREE.sRGBEncoding;
    // renderer.setPixelRatio(Math.min(2, window.devicePixelRatio));
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    const planeGeometry = new THREE.PlaneGeometry(100, 100, 1, 1);
    planeGeometry.rotateX(-Math.PI / 2);
    planeMaterial = new THREE.ShadowMaterial({ color: 0x000000, opacity: 0.2 });
    ground = new THREE.Mesh(planeGeometry, planeMaterial);
    ground.position.set(0, 0, 0);
    ground.receiveShadow = true;
    scene.add(ground);
    // console.log("8thwall scene hdriTexture", hdriTexture);
    // applyHDRITexture(scene, hdriTexture, renderer);
    // Set the initial camera position relative to the scene we just laid out. This must be at a
    // height greater than y=0.
    setUpScene({ scene, renderer, camera });
    camera.position.set(0, 1.25, 0);

    console.log("Calling sync");
    // Sync the xr controller's 6DoF position and camera paremeters with our scene.
    XR8.XrController.updateCameraProjectionMatrix({
      origin: camera.position,
      facing: camera.quaternion,
    });
    Event.sendSMEvent(AR_EVENTS.INITIALIZED);
  };

  const standardPipelineModules = () => {
    const { XRExtras, XR8 } = window;
    return [
      // Add camera pipeline modules.
      // Existing pipeline modules.
      XR8.GlTextureRenderer.pipelineModule(), // Draws the camera feed.
      XR8.Threejs.pipelineModule(), // Creates a ThreeJS AR Scene.
      XR8.XrController.pipelineModule(), // Enables SLAM tracking.
      XRExtras.AlmostThere.pipelineModule(), // Detects unsupported browsers and gives hints.
      XRExtras.FullWindowCanvas.pipelineModule(), // Modifies the canvas to fill the window.
      XRExtras.Loading.pipelineModule(), // Manages the loading screen on startup.
      XRExtras.RuntimeError.pipelineModule(), // Shows an error image on runtime error.
      window.iframeInnerPipelineModule,
    ];
  };

  const removeCanvasIfPresent = () => {
    if (document.getElementById("SCENEAR")) {
      document.body.removeChild(document.getElementById("SCENEAR"));
    }
  };
  const hitTest = () => {
    console.log("camerareturn0", hitTestStatus);
    if (!hitTestStatus) return;
    // if (hitTestStatus) window.requestAnimationFrame(hitTest(callback));

    if (camera == null) {
      console.log("camerareturn", hitTestStatus);
      return;
    }

    const hitTestResults = window.XR8.XrController.hitTest(0.5, 0.5, [
      "FEATURE_POINT",
    ]);

    const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
    raycaster.setFromCamera(tapPosition, camera);
    const intersects = raycaster.intersectObject(ground, false);

    if (intersects.length > 0 && hitTestResults.length > 0) {
      const [intersect] = intersects;
      console.log(
        "intersets arselection",
        intersect.point,
        intersect.object,
        camera.position,
        hitTestResults,
        hitTestResults[0].position,
        hitTestResults[0].distance
      );
      hitTestPosition.set(
        clamp(intersect.point.x, -10, 10),
        0,
        clamp(intersect.point.z, -10, 30)
      );
      // hitTestPosition.set(
      //   clamp(hitTestResults[0].position.x, -10, 10),
      //   hitTestResults[0].position.y,
      //   clamp(hitTestResults[0].position.z, -10, 30)
      // );
      hitTestRotation.y = camera.rotation.y;
      // callback({ position: hitTestPosition, rotation: hitTestRotation });
      hittestCallback({ position: hitTestPosition, rotation: hitTestRotation });

      if (!seekStartEvent) {
        Event.sendSMEvent(AR_POSITION_SEEK.SEEKING);
        seekStartEvent = true;
      }
      // window.XR8.XrController.recenter();
    }
  };
  const startAR = (hdriTexture) => {
    const launch8thWallAR = () => {
      console.log("Calling Launch for 8th Wall");
      const { XR8 } = window;
      XR8.XrController.configure({ enableLighting: true, imageTargets: [] }); // Disable default image targets.
      XR8.addCameraPipelineModules([
        ...standardPipelineModules(),
        // Custom pipeline modules.
        {
          name: "pipelinemodule",
          onStart: () => {
            initXrScene(hdriTexture); // Add objects set the starting camera position.
          },
          onUpdate: () => {
            hitTest();
          },
        },
        {
          name: "mypipelinemod",
          onUpdate: ({ processCpuResult }) => {
            if (!processCpuResult.reality) {
              return;
            }
            console.log("light settings", processCpuResult.reality.lighting);
          },
        },
      ]);

      console.log("8thwall inserting camerafeed");
      // if (document.getElementById(THREEJS_NAMES.SCENE_NAME) == null) {
      removeCanvasIfPresent();
      const canvas = document.createElement("canvas");
      canvas.id = "SCENEAR";
      canvas.classList.add("SCENE");
      document.body.appendChild(canvas);
      // }

      XR8.run({
        canvas,
        verbose: true,
      });

      // This removes the loading spinner shown by 8th Wall
      const loadingContainer = document.getElementById("loadingContainer");
      if (loadingContainer != null) loadingContainer.remove();
      console.log("Starting 8th wall");
    };

    // console.log("Calling Launch ");
    if (session) return;
    session = true;
    if (window.XR8) {
      console.log("Calling Launch ");
      launch8thWallAR();
    } else {
      console.log("Calling Launch wait");
      window.addEventListener("xrloaded", launch8thWallAR);
    }
  };

  const startHitTest = (callback) => {
    console.log("Starting Hit Test");
    hitTestStatus = true;
    seekStartEvent = false;
    hittestCallback = callback;
    // window.requestAnimationFrame(hitTest(callback));
  };

  const stopHitTest = () => {
    hitTestStatus = false;
  };

  const stopAR = () => {
    console.log("Calling Launch stop");
    if (!session) return;
    stopHitTest();
    session = false;
    const { XR8 } = window;
    XR8.stop();
    XR8.clearCameraPipelineModules();
    const element = document.getElementById("SCENEAR");
    if (element != null) {
      element.style.opacity = 0;
      element.style.zIndex = 1;
    }
    [scene, camera, renderer] = [null, null, null];
  };

  return {
    isSupported,
    checkSupport: (callback) => {
      const set8thWallSupport = () => {
        console.log("8th Wall checking support");
        const checkCompatibility =
          window.XR8.XrDevice.isDeviceBrowserCompatible;
        support = checkCompatibility()
          ? AR_SUPPORT.SUPPORTED
          : AR_SUPPORT.NOT_SUPPORTED;
        reason = "";
        callback(isSupported());
      };

      console.log("8th Wall checking support and if XR8 is loaded", window.XR8);
      if (window.XR8) {
        set8thWallSupport();
      } else {
        window.addEventListener("xrloaded", set8thWallSupport);
      }
    },
    startAR,
    stopAR,
    startHitTest,
    stopHitTest,
    getSceneDetails: () => ({ scene, camera, renderer }),
    getScale: () => 1,
    setOpacity: (y) => {
      planeMaterial.opacity = 0.2 - 0.3 * y;
    },
  };
};

const EighthWall = mod();
export default EighthWall;
